import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Paragraph } from "BaseComponents/Text";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

const Wrapper = styled.a`
	background-color: ${({ theme }) => theme.colors.primary};
	padding: 7px;
	height: 105px;
	justify-content: center;
	border-radius: 3px;
	flex-direction: column;
	align-items: center;
	transition: 0.2s ease;
	width: 111px;
	display: flex;
	&:hover {
		transition: 0.2s ease;
		background-color: ${({ theme }) => theme.colors.bg1};
		p {
			color: black;
		}
	}
	${media.lessThan(breakpoints.mobile)`	
	flex-basis: 33%;
	max-width: 111px;
`}
`;

const Circle = styled.div`
	min-height: 65px;
	min-width: 65px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.lightgrey};
`;

const Text = styled(Paragraph)`
	line-height: 26px;
	text-align: center;
	margin-bottom: auto;
	& {
		font-size: 14px;
	}
	transition: 0.2s ease;
	color: white;
	text-overflow: ellipsis;
	overflow: hidden;
	max-width: 90%;
	white-space: nowrap;
`;

const Img = styled.i`
	font-size: 32px;
	color: black;
`;

export const Puff = ({ Heading, Icon, Link }) => {
	const { Target, Url } = Link;
	return (
		<Wrapper target={Target} href={Url}>
			<Circle>{Icon.length > 0 && <Img className={Icon} />}</Circle>
			<Text>{Heading}</Text>
		</Wrapper>
	);
};

Puff.propTypes = {
	ListHeadline: PropTypes.string,
	ListIcon: PropTypes.string,
	Url: PropTypes.string,
	ListPreamble: PropTypes.string,
	ButtonAriaLabel: PropTypes.string,
	ListButtonHeading: PropTypes.string,
};
